export const ReportDocs = [
    {
        title: 'Muncie Abandonment Report',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_a40fdb0fb4c04f90a86b0fb0b50c4fc3.pdf'
    },
    {
        title: 'Policy Recommendations',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_14703506c0144c11a7061da90c10f6b4.pdf'
    },
    {
        title: 'Land Banks & Land Banking',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_7168e0724dbe456782de4d13b3d3816e.pdf'
    },
    {
        title: 'Data-Driven Enforcement Program for Gary, IN',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_f78961e1df52486eab1933df0d8f4dc4.pdf'
    },
    {
        title: 'Land Banks Strengthening Neighborhoods',
        url: 'https://2e647e64-250a-4555-afef-de169d2805eb.filesusr.com/ugd/03e517_b4b16f655dff4fd492327a8a63fa47ae.pdf'
    }
];
